module.exports = __webpack_public_path__ + "static/img/sty weixin.755b94eb.svg";